import TrackingElement from '../../elements/tracking/TrackingElement';
import { defineElement } from '@webtides/element-js';
import { getItemListName } from '../../elements/tracking/helpers/getItemListName';
import pushEcommerceTrackingEvent from '../../elements/tracking/helpers/pushEcommerceTrackingEvent';
import CurrencyFormatter from '../../../js/helper/currency-formatter';
import getItemsArray from '../../elements/tracking/helpers/getItemsArray';
import toTrackableCategoryProduct from '../../elements/tracking/transformer/toTrackableListItemProduct';
import ProductSliderEvents from './ProductSliderEvents';
import { trackViewItemList } from '../../elements/tracking/events/trackViewItemList';
import toTrackableListItemProduct from '../../elements/tracking/transformer/toTrackableListItemProduct';

class ProductSliderTracking extends TrackingElement {
    connected() {
        super.connected();

        if (this.$trackingTarget) {
            this.$trackingTarget?.addEventListener(ProductSliderEvents.PRODUCT_LOADED, ({ detail }) => {
                const { productCards } = detail;
                this.products = productCards;
                this.observeVisibility();
            });
        }
    }

    properties() {
        return {
            id: '',
            pageTitle: '',
            templateName: '',
            products: [],
        };
    }

    getTrackingTarget() {
        return document.querySelector('product-slider');
    }

    observeVisibility() {
        if (!this.observer) {
            this.observer = new IntersectionObserver(entries => {
                entries.forEach(entry => {
                    if (entry.isIntersecting && this.products) {
                        trackViewItemList(
                            this.id,
                            this.templateName,
                            this.pageTitle,
                            this.products,
                            toTrackableListItemProduct
                        );
                        this.observer.disconnect();
                    }
                });
            });

            this.observer.observe(this.$trackingTarget);
        }
    }

    // trackSliderProduct(products) {
    //     const itemListName = getItemListName(this.templateName, this.pageTitle);
    //
    //     pushEcommerceTrackingEvent('view_item_list', {
    //         currency: CurrencyFormatter.currency(),
    //         item_list_id: this.id,
    //         item_list_name: itemListName,
    //         items: getItemsArray(products, toTrackableCategoryProduct),
    //     });
    // }
}

defineElement('product-slider-tracking', ProductSliderTracking);
